import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template, TemplatePostDetailsType, TemplateProps } from './template';

export type InfluencerInstagramAnalyticsStoryDetailsModalProps = Pick<TemplateProps, 'isAnalytics'> &
  Pick<PostModalProps<TemplatePostDetailsType>, 'posts'>;

export const InfluencerInstagramAnalyticsStoryDetailsModal = ({
  posts,
  isAnalytics
}: InfluencerInstagramAnalyticsStoryDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template isAnalytics={isAnalytics} />
    </PostModal>
  );
};
